$('.translation-switch__toggle').on('click keyup', function (event) {
    if (event.type === 'click' || (event.type === 'keyup' && (event.keyCode === 13 || event.which === 13))) {
        $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
        $(this).next().attr('aria-hidden', $(this).next().attr('aria-hidden') === 'true' ? 'false' : 'true');
        $('.header__top__menu').toggleClass('active');
        $('.translation-switch__content').toggle();
    }
});

$(document).click(function(event) {
    if (!$(event.target).closest('.translation-switch').length) {
        $('.header__top__menu').removeClass('active');
        $('.translation-switch__content').hide();
    }
});
